import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { RoutePipe } from '@smw/navigation-front';
import { UserStore } from '@smw/stores-front';
import { ButtonComponent, SmwBackgroundComponent } from '@smw/ui-front';

@Component({
  imports: [RouterLink, TranslateModule, SmwBackgroundComponent, ButtonComponent, RoutePipe],
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent {
  constructor(private userStore: UserStore) {}

  isManager = computed(() => this.userStore.user()?.roles.includes('manager'));
}
